<template>
  <div>
    <div class="header">
      <!--<div class="backgc"><img :src="myurl"></div>-->
      <div class="title">
          <!--<router-link to="/"><img :src="back"></router-link>-->
          <img :src="back" @click="goBack" v-if="showBackIcon">
        <!--{{title}}-->
        <div>{{$route.name}}</div>
        <div class="rightBtn" v-if="showRightBtn" @click="clickRight">{{rightText}}</div>
      </div>
    </div>
    <div style="height: 5.5vh"></div>
  </div>
</template>

<script>
import myurl from '@/assets/images/header-img1.png'
import back from '@/assets/images/back.png'
import {MessageBox} from 'mint-ui'
export default {
  components: {

  },
  name: 'app-header',
  props: {
    'showBackIcon': {// 用于控制返回按钮显示/隐藏
      type: Boolean,
      default: true
    },
    'showRightBtn': {// 右边按钮
      type: Boolean,
      default: false
    },
    'rightText': {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      myurl,
      back
    }
  },
  methods: {
    goBack () {
      if (this.$route.path === '/') {
        MessageBox.alert('已经到首页啦', '提示')
        return
      }
      window.history.go(-1)
    },
    clickRight () {
      this.$emit('clickRightBtn')
    }
  },
  created () {
  }
}
</script>
<style>
 *{
    padding: 0;
    margin: 0;
  }
  .header{
    width: 100%;
    height: 5.5vh;
    font-size: 1.2rem;
    position: fixed;
    background-color: #3485FA;
   /* top: 0;
    left: 0;*/
    z-index: 9;
  }
  .backgc{
    height: 3rem;
    width: 100%;
  }
  .backgc img{
    width: 100%;
    height: 100%;
  }
  .title{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content:center;
    /*position: absolute;*/
    /*padding-top: 0.4rem;*/
    color: #ffffff;
    font-size: 1.2rem;

  }
  .title img{
    display: block;
    width: 0.6rem;
    height: 1rem;
    position: absolute;
    left: 1.5rem;
    /*top: 0.7rem;*/
  }
  .rightBtn{
    position: absolute;
    right: 0.5rem;
    font-size: 0.9rem;
    color: #EFF2F6;
  }
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue